import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  container: {
    width: theme.typography.pxToRem(32),
    height: theme.typography.pxToRem(32),
    '& :hover': {
      cursor: 'pointer',
    },
  },

  containerDisabled: {
    width: theme.typography.pxToRem(32),
    height: theme.typography.pxToRem(32),
    opacity: 0.5,
    cursor: 'not-allowed',
    '& :hover': {
      cursor: 'not-allowed',
    },
  },

  photoContainer: {
    width: '100%',
    height: '100%',
    '& img': {
      maxWidth: '100%',
      height: '100%',
      borderRadius: theme.typography.pxToRem(4),
    },
  },
}));

export default useStyles;
